import React from "react";
import {Link} from 'react-router-dom';

const MobileComponent = () => (
    <div>
        <header className="fixed-top">
            <nav className="navbar navbar-expand-lg navbar-dark">
                <Link to="/dashboard" className="navbar-brand" title="Homepage">
                    <img src={"https://s3.eu-west-2.amazonaws.com/assets.vuepay.com/vuepay-text-logo-with-white.svg"} alt="VuePay Logo" style={{ padding: 5 }} />
                </Link>
            </nav>
        </header>
        <div style={{marginTop: 100, marginLeft: 20, marginRight: 20, textAlign: 'center'}}>
            For better user experience we recommend using our VuePay app which is available on Apple App store and
            Google Play store.
            <div className="app-store-icons">
                <div style={{margin: 20}}>
                    <a href="https://apps.apple.com/gb/app/vuepay/id1454657419">
                        <img
                            src={"https://s3.eu-west-2.amazonaws.com/assets.vuepay.com/Apple+App+Store+-+Small%403x.png"}
                            alt={"App App store"} width={150}/></a>
                </div>
            </div>
            <div className="app-store-icons">
                <div style={{margin: 20}}>
                    <a href={"https://play.google.com/store/apps/details?id=com.chat2fans.android"}><img
                        src={"https://s3.eu-west-2.amazonaws.com/assets.vuepay.com/Google+Play+-+Small%403x.png"}
                        alt={"Google Play store"} width={150}/></a>
                </div>
            </div>
        </div>
    </div>
);

export default MobileComponent;